import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Theme } from "@radix-ui/themes";
// CSS is loaded via link tags in index.html
import App from "./App";
import { ThemeProvider, useTheme } from "./components/ThemeProvider";
import { LanguageProvider } from "./components/LanguageProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";

function ThemedApp() {
  const { theme } = useTheme();
  return (
    <Theme
      appearance={theme}
      accentColor="brown"
      grayColor="sand"
      radius="large"
      scaling="100%"
    >
      <App />
    </Theme>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <LanguageProvider>
        <ThemeProvider>
          <ThemedApp />
        </ThemeProvider>
      </LanguageProvider>
    </ErrorBoundary>
  </StrictMode>
);
